module.exports = __webpack_public_path__ + "img/hero7.afae0b4e.png";